module.exports = __webpack_public_path__ + "static/media/we.c98db0cc.mp3";